import { createMiddlewareFromEventsMap } from '@noths/polaris-client-next-redux';

import { GAEventsMap as breadcrumbsGAEventsMap } from 'src/components/molecules/Breadcrumb/tracking/eventsMap';
import { GAEventsMap as favouritesGAEventsMap } from 'src/components/organisms/Favourites/tracking/eventsMap';
import { GAEventsMap as featuredProductGAEventsMap } from 'src/components/organisms/FeaturedProduct/tracking/eventsMap';
import { GAEventsMap as filterGAEventsMap } from 'src/components/organisms/Filter/tracking/eventsMap';
import { GAEventsMap as filterMenuGAEventsMap } from 'src/components/organisms/FilterMenu/tracking/eventsMap';
import { GAEventsMap as linkCarouselGAEventsMap } from 'src/components/organisms/LinkCarousel/tracking/eventsMap';
import { GAEventsMap as noSearchResultsGAEventsMap } from 'src/components/organisms/NoSearchResultsGuard/tracking/eventsMap';
import { GAEventsMap as productGAEventsMap } from 'src/components/organisms/ProductPage/tracking/eventsMap';
import { GAEventsMap as recommendedProductsShelfGAEventsMap } from 'src/components/organisms/RecommendedProductsShelf/tracking/eventsMap';
import { ReduxApplicationState } from './combinedReducer';
import { GAEventsMap as productsGAEventsMap } from './products/tracking/eventsMap';

export const eventsMap = {
  ...breadcrumbsGAEventsMap,
  ...favouritesGAEventsMap,
  ...featuredProductGAEventsMap,
  ...filterGAEventsMap,
  ...filterMenuGAEventsMap,
  ...noSearchResultsGAEventsMap,
  ...productsGAEventsMap,
  ...productGAEventsMap,
  ...linkCarouselGAEventsMap,
  ...recommendedProductsShelfGAEventsMap,
};

export const GAMiddleware = createMiddlewareFromEventsMap<ReduxApplicationState>(eventsMap);
